<template>
    <a :href="education.url" class="education-top-pick-wrapper">
        <div class="education-top-pick">
            <span class="education-top-pick__rank">#{{ rank }}</span>
            <h3>{{ education.name }}</h3>
            <div class="d-md-flex">
                <div v-if="education.location" class="education-top-pick__info">
                    <i class="fas fa-map-marker-alt mr-1"></i
                    >{{ education.location }}
                </div>
                <div
                    v-if="education.learningPathway"
                    class="education-top-pick__info"
                >
                    <i class="fas fa-location-arrow mr-1"></i>
                    {{ education.learningPathway }}
                </div>
                <div v-if="education.level" class="education-top-pick__info">
                    <i class="fas fa-layer-group mr-1"></i>
                    {{ education.level }}
                </div>
                <div v-if="education.duration" class="education-top-pick__info">
                    <i class="fas fa-clock mr-1"></i>
                    {{ education.duration }}
                </div>
            </div>
        </div>
    </a>
</template>

<script>
export default {
    props: {
        education: {
            type: Object,
            default() {
                return {};
            }
        },
        rank: {
            type: Number,
            default() {
                return 0;
            }
        }
    }
};
</script>

<style lang="scss" scoped>
.education-top-pick-wrapper {
    display: block;
    width: 100%;
    background-color: $white;

    @include media-breakpoint-up(xl) {
        &:nth-child(5) {
            break-before: column;
        }
    }

    &:hover {
        text-decoration: none;
    }
}

.education-top-pick {
    border-bottom: 1px solid;
    padding: 20px 0 20px 50px;
    margin: 0 20px;
    position: relative;

    @include media-breakpoint-up(xl) {
        min-height: 100px;
    }
}

.education-top-pick h3 {
    color: $color-blue;
    text-transform: uppercase;
    font-weight: bold;
}

.education-top-pick__info {
    margin-right: 2.5rem;
}

.education-top-pick__rank {
    position: absolute;
    left: 0;
    top: 10px;
    color: #e0e0e0;
    font-size: 1.575rem;
}
</style>
